var _style, _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgSeonogte(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "150 350 345.28 341.89",
    style: {
      enableBackground: "new 0 0 595.28 841.89"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _style || (_style = /*#__PURE__*/React.createElement("style", {
    type: "text/css"
  }, "\r\n    .st0{fill:none;}\r\n    .st1{fill-rule:evenodd;clip-rule:evenodd;fill:#701FFF;}\r\n")), _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("polygon", {
    className: "st0",
    points: "409.33,375.99 409.32,382.73 416.82,382.85 416.82,376.14  "
  })), /*#__PURE__*/React.createElement("polygon", {
    className: "st1",
    points: "413.34,381.05 412.59,381.04 412.59,382.29 413.34,382.3  "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st1",
    points: "413.34,378.81 412.59,378.8 412.59,380.05 413.34,380.06  "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st1",
    points: "413.34,376.58 412.59,376.57 412.59,377.82 413.34,377.83  "
  }))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("polygon", {
    className: "st0",
    points: "409.32,382.73 409.32,389.46 416.82,389.56 416.82,382.85  "
  })), /*#__PURE__*/React.createElement("polygon", {
    className: "st1",
    points: "413.34,387.77 412.59,387.76 412.59,389.01 413.34,389.02  "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st1",
    points: "413.34,385.53 412.59,385.52 412.59,386.77 413.34,386.78  "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st1",
    points: "413.34,383.3 412.59,383.29 412.59,384.54 413.34,384.55  "
  }))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("polygon", {
    className: "st0",
    points: "409.32,389.46 409.32,396.2 416.82,396.28 416.82,389.56  "
  })), /*#__PURE__*/React.createElement("polygon", {
    className: "st1",
    points: "413.34,394.49 412.59,394.49 412.59,395.73 413.34,395.74  "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st1",
    points: "413.34,392.26 412.59,392.25 412.59,393.5 413.34,393.5  "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st1",
    points: "413.34,390.03 412.59,390.02 412.59,391.26 413.34,391.27  "
  }))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("polygon", {
    className: "st0",
    points: "409.32,396.2 409.32,402.93 416.82,402.99 416.82,396.28  "
  })), /*#__PURE__*/React.createElement("polygon", {
    className: "st1",
    points: "413.34,401.22 412.59,401.21 412.59,402.46 413.34,402.46  "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st1",
    points: "413.34,398.98 412.59,398.97 412.59,400.22 413.34,400.23  "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st1",
    points: "413.34,396.75 412.59,396.74 412.59,397.99 413.34,398  "
  }))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("polygon", {
    className: "st0",
    points: "409.32,402.93 409.32,409.67 416.82,409.7 416.82,402.99  "
  })), /*#__PURE__*/React.createElement("polygon", {
    className: "st1",
    points: "413.34,407.94 412.59,407.94 412.59,409.18 413.34,409.19  "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st1",
    points: "413.34,405.7 412.59,405.7 412.59,406.95 413.34,406.95  "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st1",
    points: "413.34,403.47 412.59,403.47 412.59,404.71 413.34,404.72  "
  }))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M409.32,409.67v3.37l0,0.82c-0.02,0,0,0-0.01,0.03c-0.01,0.04-0.03,0.16-0.15,0.31l6.28,4.1 c0.52-0.77,0.94-1.71,1.18-2.75c0.13-0.52,0.18-1.08,0.2-1.64l0-0.86v-3.36L409.32,409.67z"
  })), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M413.24,414.71l-0.73-0.15c-0.06,0.36-0.21,0.71-0.38,1.04l0.66,0.35 C412.99,415.56,413.16,415.15,413.24,414.71z"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st1",
    points: "413.34,412.42 412.59,412.42 412.59,413.67 413.34,413.67  "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st1",
    points: "413.34,410.19 412.59,410.19 412.59,411.44 413.34,411.44  "
  }))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M409.16,414.2c-0.19,0.31-0.63,0.72-1.12,0.97c-0.24,0.13-0.49,0.23-0.71,0.28 c-0.11,0.04-0.2,0.04-0.3,0.06c-0.09-0.01-0.07,0.01-0.44,0.01l0,7.5c0.19,0.01,0.77-0.01,1.24-0.05 c0.46-0.06,0.93-0.13,1.35-0.25c0.87-0.22,1.67-0.54,2.41-0.95c1.48-0.81,2.8-1.9,3.84-3.47L409.16,414.2z"
  })), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M408.39,419.32l-0.19-0.72c-0.37,0.1-0.75,0.17-1.12,0.18l0.03,0.75 C407.54,419.51,407.98,419.43,408.39,419.32z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M410.5,418.37l-0.41-0.63c-0.32,0.22-0.67,0.4-1.02,0.55l0.3,0.69 C409.76,418.81,410.14,418.61,410.5,418.37z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M412.21,416.83l-0.59-0.46c-0.23,0.3-0.51,0.58-0.8,0.83l0.49,0.57 C411.64,417.48,411.95,417.17,412.21,416.83z"
  }))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    x: 399.88,
    y: 415.52,
    className: "st0",
    width: 6.72,
    height: 7.5
  })), /*#__PURE__*/React.createElement("rect", {
    x: 400.37,
    y: 418.78,
    className: "st1",
    width: 1.25,
    height: 0.75
  }), /*#__PURE__*/React.createElement("rect", {
    x: 402.61,
    y: 418.78,
    className: "st1",
    width: 1.25,
    height: 0.75
  }), /*#__PURE__*/React.createElement("rect", {
    x: 404.84,
    y: 418.78,
    className: "st1",
    width: 1.25,
    height: 0.75
  }))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    x: 393.15,
    y: 415.52,
    className: "st0",
    width: 6.72,
    height: 7.5
  })), /*#__PURE__*/React.createElement("rect", {
    x: 393.65,
    y: 418.79,
    className: "st1",
    width: 1.25,
    height: 0.75
  }), /*#__PURE__*/React.createElement("rect", {
    x: 395.89,
    y: 418.79,
    className: "st1",
    width: 1.25,
    height: 0.75
  }), /*#__PURE__*/React.createElement("rect", {
    x: 398.12,
    y: 418.78,
    className: "st1",
    width: 1.25,
    height: 0.75
  }))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    x: 386.43,
    y: 415.53,
    transform: "matrix(1 -1.148141e-03 1.148141e-03 1 -0.4811 0.4478)",
    className: "st0",
    width: 6.72,
    height: 7.5
  })), /*#__PURE__*/React.createElement("rect", {
    x: 386.93,
    y: 418.8,
    transform: "matrix(1 -1.261392e-03 1.261392e-03 1 -0.5284 0.4892)",
    className: "st1",
    width: 1.25,
    height: 0.75
  }), /*#__PURE__*/React.createElement("rect", {
    x: 389.17,
    y: 418.79,
    transform: "matrix(1 -1.139322e-03 1.139322e-03 1 -0.4773 0.4444)",
    className: "st1",
    width: 1.25,
    height: 0.75
  }), /*#__PURE__*/React.createElement("rect", {
    x: 391.4,
    y: 418.79,
    className: "st1",
    width: 1.25,
    height: 0.75
  }))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    x: 379.71,
    y: 415.54,
    transform: "matrix(1 -1.538495e-03 1.538495e-03 1 -0.6446 0.5898)",
    className: "st0",
    width: 6.72,
    height: 7.5
  })), /*#__PURE__*/React.createElement("rect", {
    x: 380.2,
    y: 418.81,
    transform: "matrix(1 -1.627602e-03 1.627602e-03 1 -0.6818 0.6204)",
    className: "st1",
    width: 1.25,
    height: 0.75
  }), /*#__PURE__*/React.createElement("rect", {
    x: 382.44,
    y: 418.8,
    transform: "matrix(1 -1.546222e-03 1.546222e-03 1 -0.6477 0.5928)",
    className: "st1",
    width: 1.25,
    height: 0.75
  }), /*#__PURE__*/React.createElement("rect", {
    x: 384.67,
    y: 418.8,
    transform: "matrix(1 -1.383462e-03 1.383462e-03 1 -0.5795 0.5334)",
    className: "st1",
    width: 1.25,
    height: 0.75
  }))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    x: 372.98,
    y: 415.55,
    transform: "matrix(1 -1.783774e-03 1.783774e-03 1 -0.7473 0.672)",
    className: "st0",
    width: 6.72,
    height: 7.5
  })), /*#__PURE__*/React.createElement("rect", {
    x: 373.48,
    y: 418.82,
    transform: "matrix(1 -1.790362e-03 1.790362e-03 1 -0.7499 0.6705)",
    className: "st1",
    width: 1.25,
    height: 0.75
  }), /*#__PURE__*/React.createElement("rect", {
    x: 375.72,
    y: 418.81,
    transform: "matrix(1 -1.790362e-03 1.790362e-03 1 -0.7499 0.6745)",
    className: "st1",
    width: 1.25,
    height: 0.75
  }), /*#__PURE__*/React.createElement("rect", {
    x: 377.95,
    y: 418.81,
    transform: "matrix(1 -1.708982e-03 1.708982e-03 1 -0.7158 0.6476)",
    className: "st1",
    width: 1.25,
    height: 0.75
  }))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    x: 366.26,
    y: 415.56,
    transform: "matrix(1 -1.675374e-03 1.675374e-03 1 -0.702 0.6198)",
    className: "st0",
    width: 6.72,
    height: 7.5
  })), /*#__PURE__*/React.createElement("rect", {
    x: 366.76,
    y: 418.83,
    transform: "matrix(1 -1.546222e-03 1.546222e-03 1 -0.6477 0.5686)",
    className: "st1",
    width: 1.25,
    height: 0.75
  }), /*#__PURE__*/React.createElement("rect", {
    x: 369,
    y: 418.83,
    transform: "matrix(1 -1.749672e-03 1.749672e-03 1 -0.7329 0.6474)",
    className: "st1",
    width: 1.25,
    height: 0.75
  }), /*#__PURE__*/React.createElement("rect", {
    x: 371.23,
    y: 418.82,
    transform: "matrix(1 -1.831052e-03 1.831052e-03 1 -0.7669 0.6816)",
    className: "st1",
    width: 1.25,
    height: 0.75
  }))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("polygon", {
    className: "st0",
    points: "366.26,415.57 359.54,415.57 359.54,423.07 366.27,423.06  "
  })), /*#__PURE__*/React.createElement("rect", {
    x: 360.03,
    y: 418.83,
    className: "st1",
    width: 1.25,
    height: 0.75
  }), /*#__PURE__*/React.createElement("rect", {
    x: 362.27,
    y: 418.83,
    className: "st1",
    width: 1.25,
    height: 0.75
  }), /*#__PURE__*/React.createElement("rect", {
    x: 364.5,
    y: 418.83,
    transform: "matrix(1 -1.261392e-03 1.261392e-03 1 -0.5285 0.4609)",
    className: "st1",
    width: 1.25,
    height: 0.75
  }))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("polygon", {
    className: "st0",
    points: "359.54,415.57 352.84,415.55 352.79,423.05 359.54,423.07  "
  })), /*#__PURE__*/React.createElement("rect", {
    x: 353.56,
    y: 418.57,
    transform: "matrix(4.760688e-03 -1 1 4.760688e-03 -66.939 771.131)",
    className: "st1",
    width: 0.75,
    height: 1.25
  }), /*#__PURE__*/React.createElement("rect", {
    x: 355.8,
    y: 418.58,
    transform: "matrix(2.441498e-03 -1 1 2.441498e-03 -63.8987 774.3535)",
    className: "st1",
    width: 0.75,
    height: 1.25
  }), /*#__PURE__*/React.createElement("rect", {
    x: 357.78,
    y: 418.83,
    className: "st1",
    width: 1.25,
    height: 0.75
  }))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M352.84,415.55c-2.22-0.02-4.44-0.04-6.63-0.11l-0.24,7.5c2.29,0.07,4.56,0.1,6.81,0.11L352.84,415.55z"
  })), /*#__PURE__*/React.createElement("polygon", {
    className: "st1",
    points: "347.83,419.5 347.85,418.75 346.6,418.72 346.58,419.47  "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st1",
    points: "350.07,419.54 350.08,418.79 348.84,418.77 348.82,419.52  "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st1",
    points: "352.3,419.56 352.31,418.81 351.06,418.8 351.05,419.55  "
  }))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M346.21,415.44c-1.09-0.04-2.18-0.08-3.26-0.14c-1.58-0.11-0.86-0.01-1.25-0.17l-4.32,6.13 c0.8,0.56,1.75,1.04,2.86,1.29c1.34,0.24,1.64,0.18,2.27,0.24c1.16,0.07,2.31,0.12,3.46,0.15L346.21,415.44z"
  })), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M341.07,419.16l0.15-0.73c-0.35-0.09-0.7-0.21-1.02-0.39l-0.37,0.65 C340.22,418.9,340.64,419.05,341.07,419.16z"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st1",
    points: "343.34,419.34 343.38,418.59 342.14,418.51 342.09,419.26  "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st1",
    points: "345.57,419.43 345.6,418.68 344.36,418.64 344.32,419.38  "
  }))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M341.71,415.12c-0.25-0.16-0.63-0.61-0.89-1.15c-0.26-0.55-0.42-1.18-0.43-1.67l-7.5,0.14 c0.04,1.76,0.48,3.33,1.18,4.81c0.73,1.46,1.72,2.86,3.31,4L341.71,415.12z"
  })), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M336.63,414.16l0.73-0.19c-0.1-0.38-0.16-0.76-0.21-1.15l-0.75,0.07 C336.45,413.32,336.52,413.75,336.63,414.16z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M337.51,416.29l0.65-0.38c-0.19-0.34-0.37-0.69-0.51-1.05l-0.7,0.28 C337.1,415.53,337.29,415.92,337.51,416.29z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M338.97,418.08l0.49-0.57c-0.28-0.25-0.55-0.53-0.79-0.84l-0.59,0.46 C338.34,417.48,338.64,417.79,338.97,418.08z"
  }))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("polygon", {
    className: "st0",
    points: "340.39,412.3 340.38,405.64 332.88,405.66 332.89,412.44  "
  })), /*#__PURE__*/React.createElement("rect", {
    x: 336.36,
    y: 406.15,
    transform: "matrix(1 -1.586912e-03 1.586912e-03 1 -0.6451 0.5349)",
    className: "st1",
    width: 0.75,
    height: 1.25
  }), /*#__PURE__*/React.createElement("rect", {
    x: 336.36,
    y: 408.38,
    className: "st1",
    width: 0.75,
    height: 1.25
  }), /*#__PURE__*/React.createElement("rect", {
    x: 336.37,
    y: 410.61,
    className: "st1",
    width: 0.75,
    height: 1.25
  }))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("polygon", {
    className: "st0",
    points: "340.38,405.64 340.37,398.91 332.87,398.94 332.88,405.66  "
  })), /*#__PURE__*/React.createElement("polygon", {
    className: "st1",
    points: "336.35,400.67 337.1,400.67 337.1,399.42 336.35,399.42  "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st1",
    points: "336.36,402.91 337.11,402.91 337.11,401.66 336.36,401.66  "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st1",
    points: "336.36,405.14 337.11,405.14 337.11,403.89 336.36,403.89  "
  }))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("polygon", {
    className: "st0",
    points: "340.37,398.91 340.36,392.18 332.86,392.23 332.87,398.94  "
  })), /*#__PURE__*/React.createElement("polygon", {
    className: "st1",
    points: "336.35,393.95 337.1,393.94 337.09,392.7 336.34,392.7  "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st1",
    points: "336.35,396.19 337.1,396.18 337.1,394.93 336.35,394.94  "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st1",
    points: "336.35,398.42 337.1,398.41 337.1,397.17 336.35,397.17  "
  }))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("polygon", {
    className: "st0",
    points: "340.36,392.18 340.35,385.45 332.85,385.51 332.86,392.23  "
  })), /*#__PURE__*/React.createElement("polygon", {
    className: "st1",
    points: "336.34,387.23 337.09,387.22 337.09,385.97 336.34,385.98  "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st1",
    points: "336.34,389.46 337.09,389.46 337.09,388.21 336.34,388.22  "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st1",
    points: "336.34,391.7 337.09,391.69 337.09,390.44 336.34,390.45  "
  }))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("polygon", {
    className: "st0",
    points: "340.35,385.45 340.34,378.71 332.84,378.8 332.85,385.51  "
  })), /*#__PURE__*/React.createElement("polygon", {
    className: "st1",
    points: "336.33,380.5 337.08,380.5 337.08,379.25 336.33,379.26  "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st1",
    points: "336.33,382.74 337.08,382.73 337.08,381.49 336.33,381.49  "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st1",
    points: "336.34,384.97 337.09,384.97 337.08,383.72 336.33,383.72  "
  }))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("polygon", {
    className: "st0",
    points: "340.34,378.71 340.33,371.98 332.84,372.08 332.84,378.8  "
  })), /*#__PURE__*/React.createElement("polygon", {
    className: "st1",
    points: "336.32,373.78 337.07,373.77 337.07,372.52 336.32,372.53  "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st1",
    points: "336.32,376.02 337.07,376.01 337.07,374.76 336.32,374.77  "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st1",
    points: "336.33,378.25 337.08,378.24 337.08,376.99 336.33,377  "
  }))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("polygon", {
    className: "st0",
    points: "340.33,371.98 340.33,365.25 332.83,365.37 332.84,372.08  "
  })), /*#__PURE__*/React.createElement("polygon", {
    className: "st1",
    points: "336.31,367.06 337.06,367.05 337.06,365.8 336.31,365.81  "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st1",
    points: "336.32,369.3 337.07,369.29 337.06,368.04 336.31,368.05  "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st1",
    points: "336.32,371.53 337.07,371.52 337.07,370.27 336.32,370.28  "
  }))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M340.33,365.25l0-1.68l0-0.42l0-0.11l-0.01-0.19l-0.03-0.38c-0.03-0.52-0.14-1-0.26-1.48 c-0.53-1.89-1.56-3.41-2.85-4.6l-5.07,5.53c0.36,0.32,0.6,0.75,0.67,1.02c0.01,0.07,0.04,0.13,0.03,0.17l0,0.04l0.01,0.02 l0,0.1l0,0.42l0,1.68L340.33,365.25z"
  })), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M335.53,360.63l0.64-0.4c-0.24-0.38-0.51-0.74-0.82-1.06l-0.55,0.51 C335.08,359.97,335.32,360.29,335.53,360.63z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M336.27,362.61l0.74-0.1c-0.08-0.45-0.18-0.9-0.36-1.32l-0.7,0.28 C336.11,361.84,336.2,362.22,336.27,362.61z"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st1",
    points: "336.31,364.8 337.06,364.79 337.06,363.55 336.31,363.56  "
  }))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M337.18,356.39c-1.3-1.18-2.91-2.1-4.88-2.43c-0.47-0.09-1.02-0.11-1.49-0.12l-0.84,0.01l-1.68,0.02 l0.07,7.5l1.69-0.02l0.84-0.01c0.09,0.02,0.1,0,0.18,0.02c0.25,0.03,0.69,0.23,1.04,0.56L337.18,356.39z"
  })), /*#__PURE__*/React.createElement("rect", {
    x: 328.83,
    y: 357.12,
    transform: "matrix(0.9999 -0.0109 0.0109 0.9999 -3.8933 3.6275)",
    className: "st1",
    width: 1.25,
    height: 0.75
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M332.22,358.05l0.21-0.72c-0.43-0.13-0.89-0.21-1.35-0.22l-0.02,0.75 C331.45,357.87,331.84,357.94,332.22,358.05z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M334.09,359.03l0.46-0.59c-0.35-0.27-0.73-0.52-1.13-0.72l-0.33,0.67 C333.44,358.57,333.78,358.79,334.09,359.03z"
  }))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("polygon", {
    className: "st0",
    points: "328.29,353.86 321.59,353.91 321.63,361.41 328.37,361.36  "
  })), /*#__PURE__*/React.createElement("rect", {
    x: 322.1,
    y: 357.17,
    transform: "matrix(1 -6.266408e-03 6.266408e-03 1 -2.2342 2.0294)",
    className: "st1",
    width: 1.25,
    height: 0.75
  }), /*#__PURE__*/React.createElement("rect", {
    x: 324.34,
    y: 357.16,
    transform: "matrix(1 -7.649827e-03 7.649827e-03 1 -2.7255 2.4964)",
    className: "st1",
    width: 1.25,
    height: 0.75
  }), /*#__PURE__*/React.createElement("rect", {
    x: 326.57,
    y: 357.14,
    transform: "matrix(1 -9.236636e-03 9.236636e-03 1 -3.2883 3.0374)",
    className: "st1",
    width: 1.25,
    height: 0.75
  }))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("polygon", {
    className: "st0",
    points: "321.59,353.91 314.88,353.94 314.89,361.43 321.63,361.41  "
  })), /*#__PURE__*/React.createElement("rect", {
    x: 315.38,
    y: 357.2,
    transform: "matrix(1 -2.726227e-03 2.726227e-03 1 -0.9736 0.8628)",
    className: "st1",
    width: 1.25,
    height: 0.75
  }), /*#__PURE__*/React.createElement("rect", {
    x: 317.62,
    y: 357.19,
    transform: "matrix(1 -3.743463e-03 3.743463e-03 1 -1.3363 1.1938)",
    className: "st1",
    width: 1.25,
    height: 0.75
  }), /*#__PURE__*/React.createElement("rect", {
    x: 319.85,
    y: 357.18,
    transform: "matrix(1 -4.923443e-03 4.923443e-03 1 -1.7565 1.5822)",
    className: "st1",
    width: 1.25,
    height: 0.75
  }))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("polygon", {
    className: "st0",
    points: "314.88,353.94 308.16,353.94 308.16,361.44 314.89,361.43  "
  })), /*#__PURE__*/React.createElement("rect", {
    x: 308.66,
    y: 357.21,
    className: "st1",
    width: 1.25,
    height: 0.75
  }), /*#__PURE__*/React.createElement("rect", {
    x: 310.9,
    y: 357.2,
    className: "st1",
    width: 1.25,
    height: 0.75
  }), /*#__PURE__*/React.createElement("rect", {
    x: 313.13,
    y: 357.2,
    transform: "matrix(1 -1.790362e-03 1.790362e-03 1 -0.6397 0.5623)",
    className: "st1",
    width: 1.25,
    height: 0.75
  }))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("polygon", {
    className: "st0",
    points: "308.16,353.94 301.44,353.94 301.43,361.43 308.16,361.44  "
  })), /*#__PURE__*/React.createElement("rect", {
    x: 302.18,
    y: 356.95,
    transform: "matrix(1.180012e-03 -1 1 1.180012e-03 -55.3741 659.7133)",
    className: "st1",
    width: 0.75,
    height: 1.25
  }), /*#__PURE__*/React.createElement("rect", {
    x: 304.17,
    y: 357.2,
    className: "st1",
    width: 1.25,
    height: 0.75
  }), /*#__PURE__*/React.createElement("rect", {
    x: 306.4,
    y: 357.21,
    className: "st1",
    width: 1.25,
    height: 0.75
  }))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    x: 294.33,
    y: 354.32,
    transform: "matrix(1.611642e-03 -1 1 1.611642e-03 -60.0825 655.1791)",
    className: "st0",
    width: 7.5,
    height: 6.72
  })), /*#__PURE__*/React.createElement("rect", {
    x: 295.46,
    y: 356.94,
    transform: "matrix(1.708982e-03 -1 1 1.708982e-03 -62.2351 652.7905)",
    className: "st1",
    width: 0.75,
    height: 1.25
  }), /*#__PURE__*/React.createElement("rect", {
    x: 297.7,
    y: 356.95,
    transform: "matrix(1.586912e-03 -1 1 1.586912e-03 -59.9681 655.0761)",
    className: "st1",
    width: 0.75,
    height: 1.25
  }), /*#__PURE__*/React.createElement("rect", {
    x: 299.93,
    y: 356.95,
    transform: "matrix(1.505532e-03 -1 1 1.505532e-03 -57.72 657.3397)",
    className: "st1",
    width: 0.75,
    height: 1.25
  }))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    x: 287.6,
    y: 354.31,
    transform: "matrix(1.438404e-03 -1 1 1.438404e-03 -66.7342 648.5078)",
    className: "st0",
    width: 7.5,
    height: 6.72
  })), /*#__PURE__*/React.createElement("rect", {
    x: 288.74,
    y: 356.93,
    transform: "matrix(1.261392e-03 -1 1 1.261392e-03 -68.8075 646.2173)",
    className: "st1",
    width: 0.75,
    height: 1.25
  }), /*#__PURE__*/React.createElement("rect", {
    x: 290.98,
    y: 356.93,
    transform: "matrix(1.546222e-03 -1 1 1.546222e-03 -66.6578 648.3565)",
    className: "st1",
    width: 0.75,
    height: 1.25
  }), /*#__PURE__*/React.createElement("rect", {
    x: 293.21,
    y: 356.94,
    transform: "matrix(1.627602e-03 -1 1 1.627602e-03 -64.4577 650.5618)",
    className: "st1",
    width: 0.75,
    height: 1.25
  }))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("polygon", {
    className: "st0",
    points: "288,353.91 281.27,353.91 281.27,361.41 287.99,361.41  "
  })), /*#__PURE__*/React.createElement("rect", {
    x: 281.77,
    y: 357.18,
    className: "st1",
    width: 1.25,
    height: 0.75
  }), /*#__PURE__*/React.createElement("rect", {
    x: 284,
    y: 357.18,
    className: "st1",
    width: 1.25,
    height: 0.75
  }), /*#__PURE__*/React.createElement("rect", {
    x: 286.23,
    y: 357.18,
    className: "st1",
    width: 1.25,
    height: 0.75
  }))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("polygon", {
    className: "st0",
    points: "281.27,353.91 274.53,353.92 274.56,361.42 281.27,361.41  "
  })), /*#__PURE__*/React.createElement("rect", {
    x: 275.04,
    y: 357.19,
    transform: "matrix(1 -2.441399e-03 2.441399e-03 1 -0.8721 0.6741)",
    className: "st1",
    width: 1.25,
    height: 0.75
  }), /*#__PURE__*/React.createElement("rect", {
    x: 277.28,
    y: 357.18,
    transform: "matrix(1 -1.464842e-03 1.464842e-03 1 -0.5235 0.4075)",
    className: "st1",
    width: 1.25,
    height: 0.75
  }), /*#__PURE__*/React.createElement("rect", {
    x: 279.51,
    y: 357.18,
    className: "st1",
    width: 1.25,
    height: 0.75
  }))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("polygon", {
    className: "st0",
    points: "274.53,353.92 267.8,353.96 267.85,361.46 274.56,361.42  "
  })), /*#__PURE__*/React.createElement("rect", {
    x: 268.32,
    y: 357.22,
    transform: "matrix(1 -5.818823e-03 5.818823e-03 1 -2.0762 1.571)",
    className: "st1",
    width: 1.25,
    height: 0.75
  }), /*#__PURE__*/React.createElement("rect", {
    x: 270.56,
    y: 357.2,
    transform: "matrix(1 -4.557244e-03 4.557244e-03 1 -1.6268 1.2396)",
    className: "st1",
    width: 1.25,
    height: 0.75
  }), /*#__PURE__*/React.createElement("rect", {
    x: 272.79,
    y: 357.19,
    transform: "matrix(1 -3.417949e-03 3.417949e-03 1 -1.2206 0.9366)",
    className: "st1",
    width: 1.25,
    height: 0.75
  }))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M267.8,353.96l-6.63,0.06c-0.29,0.01-0.57,0.05-0.85,0.09l1.58,7.4l5.95-0.05L267.8,353.96z"
  })), /*#__PURE__*/React.createElement("polygon", {
    className: "st1",
    points: "262.85,358.02 262.84,357.27 261.56,357.28 261.62,358.03  "
  }), /*#__PURE__*/React.createElement("rect", {
    x: 263.83,
    y: 357.25,
    transform: "matrix(1 -8.707707e-03 8.707707e-03 1 -3.1041 2.3164)",
    className: "st1",
    width: 1.25,
    height: 0.75
  }), /*#__PURE__*/React.createElement("rect", {
    x: 266.06,
    y: 357.23,
    transform: "matrix(1 -7.201962e-03 7.201962e-03 1 -2.5685 1.93)",
    className: "st1",
    width: 1.25,
    height: 0.75
  }))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M260.32,354.11c-2.22,0.23-4.09,1.78-5.03,3.79c-0.25,0.48-0.45,1.06-0.59,1.53 c-0.12,0.42-0.21,0.79-0.28,1.17c-0.14,0.74-0.22,1.45-0.26,2.12l7.48,0.49c0.03-0.44,0.08-0.85,0.15-1.21 c0.03-0.17,0.07-0.35,0.11-0.46l0.01-0.03L260.32,354.11z"
  })), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M258.37,361.29l-0.74-0.14c-0.09,0.43-0.14,0.86-0.18,1.28l0.75,0.07 C258.24,362.09,258.29,361.69,258.37,361.29z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M259.08,359.31l-0.6-0.47c-0.25,0.39-0.44,0.83-0.58,1.28l0.71,0.25 C258.73,360,258.87,359.64,259.08,359.31z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M260.69,358.1l-0.25-0.72c-0.46,0.1-0.87,0.33-1.24,0.62l0.47,0.6 C259.96,358.38,260.31,358.17,260.69,358.1z"
  }))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M254.16,362.73c-0.09,1.42-0.04,2.42-0.05,3.57l0.01,3.37l7.5,0.07l-0.01-3.36 c0.01-1.1-0.03-2.33,0.03-3.15L254.16,362.73z"
  })), /*#__PURE__*/React.createElement("polygon", {
    className: "st1",
    points: "258.13,367.95 257.38,367.94 257.38,369.19 258.13,369.2  "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st1",
    points: "258.12,365.71 257.37,365.7 257.38,366.95 258.13,366.96  "
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M258.14,363.49l-0.75-0.03c-0.02,0.43-0.02,0.85-0.02,1.26l0.75,0.01 C258.12,364.31,258.12,363.9,258.14,363.49z"
  }))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("polygon", {
    className: "st0",
    points: "254.12,369.66 254.13,376.39 261.63,376.44 261.62,369.72  "
  })), /*#__PURE__*/React.createElement("polygon", {
    className: "st1",
    points: "258.15,374.67 257.4,374.67 257.4,375.91 258.15,375.92  "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st1",
    points: "258.14,372.43 257.39,372.43 257.39,373.68 258.14,373.68  "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st1",
    points: "258.13,370.2 257.38,370.2 257.39,371.45 258.14,371.45  "
  }))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("polygon", {
    className: "st0",
    points: "254.13,376.39 254.15,383.12 261.65,383.16 261.63,376.44  "
  })), /*#__PURE__*/React.createElement("polygon", {
    className: "st1",
    points: "258.16,381.39 257.41,381.39 257.41,382.64 258.16,382.64  "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st1",
    points: "258.16,379.16 257.41,379.15 257.41,380.4 258.16,380.4  "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st1",
    points: "258.15,376.93 257.4,376.92 257.4,378.17 258.15,378.17  "
  }))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("polygon", {
    className: "st0",
    points: "254.15,383.12 254.17,389.85 261.67,389.87 261.65,383.16  "
  })), /*#__PURE__*/React.createElement("polygon", {
    className: "st1",
    points: "258.18,388.12 257.43,388.11 257.43,389.36 258.18,389.37  "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st1",
    points: "258.17,385.88 257.42,385.88 257.43,387.12 258.18,387.13  "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st1",
    points: "258.17,383.65 257.42,383.65 257.42,384.89 258.17,384.9  "
  }))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("polygon", {
    className: "st0",
    points: "254.17,389.85 254.18,396.58 261.68,396.59 261.67,389.87  "
  })), /*#__PURE__*/React.createElement("polygon", {
    className: "st1",
    points: "258.19,394.84 257.44,394.84 257.45,396.09 258.2,396.09  "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st1",
    points: "258.19,392.6 257.44,392.6 257.44,393.85 258.19,393.85  "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st1",
    points: "258.18,390.37 257.43,390.37 257.44,391.62 258.19,391.62  "
  }))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("polygon", {
    className: "st0",
    points: "254.18,396.58 254.2,403.31 261.7,403.3 261.68,396.59  "
  })), /*#__PURE__*/React.createElement("polygon", {
    className: "st1",
    points: "258.21,401.56 257.46,401.56 257.46,402.81 258.21,402.81  "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st1",
    points: "258.21,399.32 257.46,399.32 257.46,400.57 258.21,400.57  "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st1",
    points: "258.2,397.09 257.45,397.09 257.45,398.34 258.2,398.34  "
  }))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("polygon", {
    className: "st0",
    points: "254.2,403.31 254.22,410.04 261.72,410.02 261.7,403.3  "
  })), /*#__PURE__*/React.createElement("rect", {
    x: 257.48,
    y: 408.29,
    transform: "matrix(1 -2.197260e-03 2.197260e-03 1 -0.8979 0.5676)",
    className: "st1",
    width: 0.75,
    height: 1.25
  }), /*#__PURE__*/React.createElement("rect", {
    x: 257.47,
    y: 406.05,
    transform: "matrix(1 -1.586912e-03 1.586912e-03 1 -0.645 0.4097)",
    className: "st1",
    width: 0.75,
    height: 1.25
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st1",
    points: "258.22,403.82 257.47,403.82 257.47,405.07 258.22,405.06  "
  }))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M254.22,410.04l0,1.68l-0.01,1.52c-0.03,0.79-0.19,1.42-0.34,1.73l6.71,3.36 c0.83-1.71,1.06-3.34,1.13-4.78c0.02-0.78,0.01-1.28,0.01-1.85l0-1.68L254.22,410.04z"
  })), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M258.04,415.05l-0.74-0.15c-0.08,0.38-0.19,0.76-0.32,1.11l0.7,0.28 C257.83,415.89,257.95,415.47,258.04,415.05z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M258.24,412.77l-0.75,0c0,0.4-0.01,0.8-0.05,1.2l0.75,0.07C258.22,413.62,258.24,413.19,258.24,412.77z"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 257.49,
    y: 410.54,
    transform: "matrix(1 -2.807606e-03 2.807606e-03 1 -1.1534 0.7256)",
    className: "st1",
    width: 0.75,
    height: 1.25
  }))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M253.87,414.97c-0.18,0.29-0.19,0.32-0.5,0.46c-0.14,0.07-0.39,0.12-0.67,0.17 c-0.13,0.03-0.32,0.02-0.48,0.04l-0.13,0.01l-0.21,0l-0.42,0.01l0.11,7.5l0.42-0.01l0.21,0l0.29-0.02 c0.4-0.03,0.77-0.03,1.19-0.1c0.82-0.12,1.68-0.3,2.57-0.68c0.88-0.34,1.77-0.92,2.53-1.61c0.76-0.71,1.35-1.55,1.79-2.4 L253.87,414.97z"
  })), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M253.3,419.56l-0.11-0.74c-0.39,0.06-0.78,0.07-1.18,0.09l0.01,0.75 C252.44,419.63,252.88,419.63,253.3,419.56z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M255.51,418.84l-0.37-0.65c-0.15,0.1-0.33,0.17-0.51,0.25c-0.17,0.08-0.35,0.14-0.54,0.19l0.21,0.72 c0.21-0.05,0.42-0.12,0.62-0.22C255.12,419.04,255.32,418.96,255.51,418.84z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M257.2,417.23l-0.63-0.4c-0.2,0.32-0.44,0.6-0.71,0.85l0.5,0.56C256.68,417.94,256.96,417.6,257.2,417.23z "
  }))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("polygon", {
    className: "st0",
    points: "251.47,415.65 244.78,415.71 244.82,423.21 251.58,423.14  "
  })), /*#__PURE__*/React.createElement("rect", {
    x: 245.3,
    y: 418.97,
    transform: "matrix(1 -8.300833e-03 8.300833e-03 1 -3.4724 2.0558)",
    className: "st1",
    width: 1.25,
    height: 0.75
  }), /*#__PURE__*/React.createElement("rect", {
    x: 247.53,
    y: 418.95,
    transform: "matrix(0.9999 -0.011 0.011 0.9999 -4.6003 2.7567)",
    className: "st1",
    width: 1.25,
    height: 0.75
  }), /*#__PURE__*/React.createElement("rect", {
    x: 249.76,
    y: 418.92,
    transform: "matrix(0.9999 -0.0139 0.0139 0.9999 -5.7937 3.5145)",
    className: "st1",
    width: 1.25,
    height: 0.75
  }))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("polygon", {
    className: "st0",
    points: "244.78,415.71 238.08,415.73 238.07,423.23 244.82,423.21  "
  })), /*#__PURE__*/React.createElement("rect", {
    x: 238.57,
    y: 419,
    transform: "matrix(1 -1.180012e-03 1.180012e-03 1 -0.4947 0.2825)",
    className: "st1",
    width: 1.25,
    height: 0.75
  }), /*#__PURE__*/React.createElement("rect", {
    x: 240.81,
    y: 418.99,
    transform: "matrix(1 -3.397604e-03 3.397604e-03 1 -1.4235 0.8227)",
    className: "st1",
    width: 1.25,
    height: 0.75
  }), /*#__PURE__*/React.createElement("rect", {
    x: 243.04,
    y: 418.99,
    transform: "matrix(1 -5.737210e-03 5.737210e-03 1 -2.4019 1.4049)",
    className: "st1",
    width: 1.25,
    height: 0.75
  }))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("polygon", {
    className: "st0",
    points: "238.08,415.73 231.37,415.71 231.33,423.21 238.07,423.23  "
  })), /*#__PURE__*/React.createElement("rect", {
    x: 232.1,
    y: 418.73,
    transform: "matrix(4.252078e-03 -1 1 4.252078e-03 -187.8677 650.0467)",
    className: "st1",
    width: 0.75,
    height: 1.25
  }), /*#__PURE__*/React.createElement("rect", {
    x: 234.34,
    y: 418.74,
    transform: "matrix(2.665192e-03 -1 1 2.665192e-03 -185.2785 652.9609)",
    className: "st1",
    width: 0.75,
    height: 1.25
  }), /*#__PURE__*/React.createElement("rect", {
    x: 236.32,
    y: 419,
    className: "st1",
    width: 1.25,
    height: 0.75
  }))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("polygon", {
    className: "st0",
    points: "231.37,415.71 224.66,415.66 224.6,423.16 231.33,423.21  "
  })), /*#__PURE__*/React.createElement("rect", {
    x: 225.38,
    y: 418.69,
    transform: "matrix(8.117738e-03 -1 1 8.117738e-03 -195.3802 641.6539)",
    className: "st1",
    width: 0.75,
    height: 1.25
  }), /*#__PURE__*/React.createElement("rect", {
    x: 227.61,
    y: 418.71,
    transform: "matrix(6.978183e-03 -1 1 6.978183e-03 -192.9212 644.3885)",
    className: "st1",
    width: 0.75,
    height: 1.25
  }), /*#__PURE__*/React.createElement("rect", {
    x: 229.85,
    y: 418.72,
    transform: "matrix(5.777898e-03 -1 1 5.777898e-03 -190.4484 647.1397)",
    className: "st1",
    width: 0.75,
    height: 1.25
  }))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("polygon", {
    className: "st0",
    points: "224.66,415.66 217.95,415.6 217.87,423.1 224.6,423.16  "
  })), /*#__PURE__*/React.createElement("rect", {
    x: 218.65,
    y: 418.63,
    transform: "matrix(9.989735e-03 -1 1 9.989735e-03 -202.3879 634.0801)",
    className: "st1",
    width: 0.75,
    height: 1.25
  }), /*#__PURE__*/React.createElement("rect", {
    x: 220.89,
    y: 418.65,
    transform: "matrix(9.643499e-03 -1 1 9.643499e-03 -200.1194 636.4861)",
    className: "st1",
    width: 0.75,
    height: 1.25
  }), /*#__PURE__*/React.createElement("rect", {
    x: 223.12,
    y: 418.67,
    transform: "matrix(8.910779e-03 -1 1 8.910779e-03 -197.7701 639.0461)",
    className: "st1",
    width: 0.75,
    height: 1.25
  }))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    x: 210.8,
    y: 415.95,
    transform: "matrix(0.0101 -0.9999 0.9999 0.0101 -206.9065 629.6299)",
    className: "st0",
    width: 7.5,
    height: 6.72
  })), /*#__PURE__*/React.createElement("rect", {
    x: 211.93,
    y: 418.56,
    transform: "matrix(9.928300e-03 -1 1 9.928300e-03 -208.9628 627.3162)",
    className: "st1",
    width: 0.75,
    height: 1.25
  }), /*#__PURE__*/React.createElement("rect", {
    x: 214.17,
    y: 418.58,
    transform: "matrix(0.0102 -0.9999 0.9999 0.0102 -206.8204 629.4733)",
    className: "st1",
    width: 0.75,
    height: 1.25
  }), /*#__PURE__*/React.createElement("rect", {
    x: 216.4,
    y: 418.6,
    transform: "matrix(0.0103 -0.9999 0.9999 0.0103 -204.6526 631.6924)",
    className: "st1",
    width: 0.75,
    height: 1.25
  }))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("polygon", {
    className: "st0",
    points: "211.22,415.53 204.49,415.48 204.44,422.98 211.15,423.03  "
  })), /*#__PURE__*/React.createElement("rect", {
    x: 205.21,
    y: 418.5,
    transform: "matrix(7.629483e-03 -1 1 7.629483e-03 -215.0962 621.5026)",
    className: "st1",
    width: 0.75,
    height: 1.25
  }), /*#__PURE__*/React.createElement("rect", {
    x: 207.45,
    y: 418.52,
    transform: "matrix(8.605989e-03 -1 1 8.605989e-03 -213.0925 623.3476)",
    className: "st1",
    width: 0.75,
    height: 1.25
  }), /*#__PURE__*/React.createElement("rect", {
    x: 209.68,
    y: 418.54,
    transform: "matrix(9.419724e-03 -1 1 9.419724e-03 -211.068 625.255)",
    className: "st1",
    width: 0.75,
    height: 1.25
  }))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("polygon", {
    className: "st0",
    points: "204.49,415.48 197.74,415.45 197.74,422.95 204.44,422.98  "
  })), /*#__PURE__*/React.createElement("rect", {
    x: 198.48,
    y: 418.47,
    transform: "matrix(2.604158e-03 -1 1 2.604158e-03 -220.7471 616.8577)",
    className: "st1",
    width: 0.75,
    height: 1.25
  }), /*#__PURE__*/React.createElement("rect", {
    x: 200.72,
    y: 418.47,
    transform: "matrix(4.638622e-03 -1 1 4.638622e-03 -218.9276 618.2491)",
    className: "st1",
    width: 0.75,
    height: 1.25
  }), /*#__PURE__*/React.createElement("rect", {
    x: 202.95,
    y: 418.48,
    transform: "matrix(6.205374e-03 -1 1 6.205374e-03 -217.0332 619.8331)",
    className: "st1",
    width: 0.75,
    height: 1.25
  }))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("polygon", {
    className: "st0",
    points: "197.74,415.45 190.99,415.47 191.05,422.97 197.74,422.95  "
  })), /*#__PURE__*/React.createElement("rect", {
    x: 191.51,
    y: 418.73,
    transform: "matrix(1 -5.411925e-03 5.411925e-03 1 -2.2653 1.046)",
    className: "st1",
    width: 1.25,
    height: 0.75
  }), /*#__PURE__*/React.createElement("rect", {
    x: 193.75,
    y: 418.72,
    transform: "matrix(1 -2.339675e-03 2.339675e-03 1 -0.98 0.4559)",
    className: "st1",
    width: 1.25,
    height: 0.75
  }), /*#__PURE__*/React.createElement("rect", {
    x: 195.98,
    y: 418.71,
    className: "st1",
    width: 1.25,
    height: 0.75
  }))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M190.99,415.47l-3.38,0.04l-0.85,0.01c-0.36,0.01-0.7,0.02-1.08,0.05c-0.75,0.06-1.56,0.17-2.49,0.46 l2.29,7.14c0.13-0.05,0.44-0.1,0.81-0.13c0.18-0.02,0.39-0.02,0.6-0.03l0.83-0.01l3.34-0.04L190.99,415.47z"
  })), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M186.06,419.57l-0.06-0.75c-0.43,0.02-0.87,0.09-1.31,0.18l0.16,0.73 C185.25,419.65,185.65,419.59,186.06,419.57z"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 187.03,
    y: 418.77,
    transform: "matrix(0.9999 -0.0127 0.0127 0.9999 -5.323 2.4239)",
    className: "st1",
    width: 1.25,
    height: 0.75
  }), /*#__PURE__*/React.createElement("rect", {
    x: 189.26,
    y: 418.75,
    transform: "matrix(1 -8.728050e-03 8.728050e-03 1 -3.6509 1.6733)",
    className: "st1",
    width: 1.25,
    height: 0.75
  }))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M183.18,416.03c-0.96,0.3-2.04,0.87-2.84,1.62c-0.82,0.73-1.48,1.8-1.84,2.61 c-0.19,0.42-0.42,1.01-0.52,1.54c-0.06,0.27-0.09,0.55-0.12,0.83l-0.04,0.56c-0.04,0.66-0.05,1.24-0.06,1.83l7.5,0.14 c0.01-0.53,0.02-1.06,0.05-1.53l0.02-0.28l0.02-0.05c0.1-0.2,0.05-0.11,0.06-0.13c0.03-0.01-0.06,0.02,0.05-0.02 L183.18,416.03z"
  })), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M181.84,423.37l-0.75-0.05c-0.03,0.43-0.04,0.85-0.05,1.26l0.75,0.02 C181.8,424.2,181.81,423.78,181.84,423.37z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M182.44,421.38l-0.64-0.39c-0.24,0.4-0.41,0.81-0.57,1.26l0.72,0.2 C182.08,422.09,182.24,421.72,182.44,421.38z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M183.96,420.03l-0.31-0.68c-0.43,0.19-0.83,0.45-1.17,0.78l0.52,0.54 C183.28,420.4,183.61,420.18,183.96,420.03z"
  }))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M177.76,425.03c-0.02,1.17-0.02,2.32-0.01,3.48l0.03,3.34l7.5-0.06l-0.03-3.38 c-0.01-1.08-0.01-2.18,0.01-3.25L177.76,425.03z"
  })), /*#__PURE__*/React.createElement("rect", {
    x: 181.04,
    y: 430.08,
    transform: "matrix(0.9999 -0.0105 0.0105 0.9999 -4.529 1.9358)",
    className: "st1",
    width: 0.75,
    height: 1.25
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st1",
    points: "181.76,427.84 181.01,427.85 181.02,429.1 181.77,429.09  "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st1",
    points: "181.77,425.61 181.02,425.6 181.01,426.86 181.76,426.86  "
  }))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("polygon", {
    className: "st0",
    points: "177.79,431.85 177.81,438.54 185.3,438.55 185.29,431.8  "
  })), /*#__PURE__*/React.createElement("rect", {
    x: 181.07,
    y: 436.8,
    className: "st1",
    width: 0.75,
    height: 1.25
  }), /*#__PURE__*/React.createElement("rect", {
    x: 181.07,
    y: 434.57,
    transform: "matrix(1 -3.417949e-03 3.417949e-03 1 -1.4864 0.6227)",
    className: "st1",
    width: 0.75,
    height: 1.25
  }), /*#__PURE__*/React.createElement("rect", {
    x: 181.06,
    y: 432.33,
    transform: "matrix(1 -6.795229e-03 6.795229e-03 1 -2.9379 1.2429)",
    className: "st1",
    width: 0.75,
    height: 1.25
  }))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("polygon", {
    className: "st0",
    points: "177.81,438.54 177.77,445.24 185.27,445.3 185.3,438.55  "
  })), /*#__PURE__*/React.createElement("rect", {
    x: 180.79,
    y: 443.77,
    transform: "matrix(6.673164e-03 -1 1 6.673164e-03 -263.9312 622.6)",
    className: "st1",
    width: 1.25,
    height: 0.75
  }), /*#__PURE__*/React.createElement("rect", {
    x: 180.81,
    y: 441.54,
    transform: "matrix(4.720096e-03 -1 1 4.720096e-03 -261.33 621.256)",
    className: "st1",
    width: 1.25,
    height: 0.75
  }), /*#__PURE__*/React.createElement("rect", {
    x: 180.82,
    y: 439.31,
    transform: "matrix(2.319377e-03 -1 1 2.319377e-03 -258.6586 620.1019)",
    className: "st1",
    width: 1.25,
    height: 0.75
  }))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("polygon", {
    className: "st0",
    points: "177.77,445.24 177.71,451.95 185.2,452.03 185.27,445.3  "
  })), /*#__PURE__*/React.createElement("rect", {
    x: 180.73,
    y: 450.5,
    transform: "matrix(0.0105 -0.9999 0.9999 0.0105 -271.3866 627.5037)",
    className: "st1",
    width: 1.25,
    height: 0.75
  }), /*#__PURE__*/React.createElement("rect", {
    x: 180.76,
    y: 448.26,
    transform: "matrix(9.643499e-03 -1 1 9.643499e-03 -268.9819 625.6788)",
    className: "st1",
    width: 1.25,
    height: 0.75
  }), /*#__PURE__*/React.createElement("rect", {
    x: 180.78,
    y: 446.03,
    transform: "matrix(8.300833e-03 -1 1 8.300833e-03 -266.4928 624.0917)",
    className: "st1",
    width: 1.25,
    height: 0.75
  }))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    x: 178.06,
    y: 451.61,
    transform: "matrix(0.0109 -0.9999 0.9999 0.0109 -275.8868 631.7997)",
    className: "st0",
    width: 6.72,
    height: 7.5
  })), /*#__PURE__*/React.createElement("rect", {
    x: 180.66,
    y: 457.22,
    transform: "matrix(0.0108 -0.9999 0.9999 0.0108 -278.2464 633.9143)",
    className: "st1",
    width: 1.25,
    height: 0.75
  }), /*#__PURE__*/React.createElement("rect", {
    x: 180.68,
    y: 454.98,
    transform: "matrix(0.0111 -0.9999 0.9999 0.0111 -276.0344 631.5945)",
    className: "st1",
    width: 1.25,
    height: 0.75
  }), /*#__PURE__*/React.createElement("rect", {
    x: 180.71,
    y: 452.75,
    transform: "matrix(0.0109 -0.9999 0.9999 0.0109 -273.7508 629.4873)",
    className: "st1",
    width: 1.25,
    height: 0.75
  }))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("polygon", {
    className: "st0",
    points: "177.63,458.68 177.57,465.42 185.07,465.46 185.13,458.75  "
  })), /*#__PURE__*/React.createElement("rect", {
    x: 180.6,
    y: 463.94,
    transform: "matrix(7.812420e-03 -1 1 7.812420e-03 -284.4982 641.9056)",
    className: "st1",
    width: 1.25,
    height: 0.75
  }), /*#__PURE__*/React.createElement("rect", {
    x: 180.62,
    y: 461.7,
    transform: "matrix(9.155262e-03 -1 1 9.155262e-03 -282.4799 639.0805)",
    className: "st1",
    width: 1.25,
    height: 0.75
  }), /*#__PURE__*/React.createElement("rect", {
    x: 180.64,
    y: 459.47,
    transform: "matrix(0.0102 -0.9999 0.9999 0.0102 -280.4085 636.4211)",
    className: "st1",
    width: 1.25,
    height: 0.75
  }))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("polygon", {
    className: "st0",
    points: "177.57,465.42 177.55,472.17 185.05,472.16 185.07,465.46  "
  })), /*#__PURE__*/React.createElement("rect", {
    x: 180.57,
    y: 470.67,
    transform: "matrix(1.424152e-03 -1 1 1.424152e-03 -290.1064 651.563)",
    className: "st1",
    width: 1.25,
    height: 0.75
  }), /*#__PURE__*/React.createElement("rect", {
    x: 180.57,
    y: 468.43,
    transform: "matrix(3.824842e-03 -1 1 3.824842e-03 -288.2952 648.2058)",
    className: "st1",
    width: 1.25,
    height: 0.75
  }), /*#__PURE__*/React.createElement("rect", {
    x: 180.58,
    y: 466.2,
    transform: "matrix(5.981460e-03 -1 1 5.981460e-03 -286.4409 644.9843)",
    className: "st1",
    width: 1.25,
    height: 0.75
  }))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("polygon", {
    className: "st0",
    points: "177.55,472.17 177.59,478.93 185.09,478.84 185.05,472.16  "
  })), /*#__PURE__*/React.createElement("rect", {
    x: 180.85,
    y: 477.14,
    transform: "matrix(1 -8.097230e-03 8.097230e-03 1 -3.8626 1.483)",
    className: "st1",
    width: 0.75,
    height: 1.25
  }), /*#__PURE__*/React.createElement("rect", {
    x: 180.83,
    y: 474.9,
    transform: "matrix(1 -4.679406e-03 4.679406e-03 1 -2.2232 0.8531)",
    className: "st1",
    width: 0.75,
    height: 1.25
  }), /*#__PURE__*/React.createElement("rect", {
    x: 180.82,
    y: 472.67,
    transform: "matrix(1 -1.505532e-03 1.505532e-03 1 -0.7124 0.2733)",
    className: "st1",
    width: 0.75,
    height: 1.25
  }))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M177.59,478.93l0.01,0.85l0.02,0.95c0.01,0.55,0.14,1.92,0.46,2.92c0.33,1.05,0.88,2.01,1.65,2.77 c0.77,0.76,1.74,1.29,2.79,1.58l2.61-7.19l-0.02-0.38l-0.02-1.57L177.59,478.93z"
  })), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M182.48,483.46l-0.54,0.55c0.32,0.35,0.73,0.59,1.17,0.74l0.35-0.68 C183.09,483.95,182.74,483.75,182.48,483.46z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M181.72,481.56l-0.73,0.16c0.07,0.46,0.18,0.92,0.36,1.35l0.66-0.39 C181.86,482.32,181.77,481.95,181.72,481.56z"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st1",
    points: "181.61,479.39 180.86,479.4 180.89,480.66 181.63,480.63  "
  }))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M182.52,487.99c0.53,0.14,1.08,0.23,1.63,0.26l0.4,0.03l0.21,0l0.42,0l1.69,0l3.38,0l0.55-7.49 l-5.67-0.01L182.52,487.99z"
  })), /*#__PURE__*/React.createElement("polygon", {
    className: "st1",
    points: "188.8,484.29 188.74,485.03 189.99,485.04 190.05,484.29  "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st1",
    points: "186.56,484.28 186.5,485.03 187.75,485.03 187.81,484.28  "
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M184.37,484.26l-0.16,0.74c0.49,0.04,0.9,0.04,1.31,0.03l0.06-0.75 C185.16,484.28,184.74,484.29,184.37,484.26z"
  }))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("polygon", {
    className: "st0",
    points: "190.25,488.29 197,488.3 197.5,480.81 190.8,480.8  "
  })), /*#__PURE__*/React.createElement("polygon", {
    className: "st1",
    points: "195.52,484.29 195.47,485.04 196.72,485.04 196.77,484.29  "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st1",
    points: "193.28,484.29 193.23,485.04 194.48,485.04 194.53,484.29  "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st1",
    points: "191.05,484.29 191,485.04 192.25,485.04 192.3,484.29  "
  }))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("polygon", {
    className: "st0",
    points: "197,488.3 203.75,488.31 204.19,480.81 197.5,480.81  "
  })), /*#__PURE__*/React.createElement("polygon", {
    className: "st1",
    points: "202.24,484.3 202.2,485.05 203.45,485.05 203.49,484.3  "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st1",
    points: "200,484.3 199.96,485.04 201.21,485.05 201.25,484.3  "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st1",
    points: "197.77,484.29 197.73,485.04 198.97,485.04 199.02,484.29  "
  }))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("polygon", {
    className: "st0",
    points: "203.75,488.31 210.5,488.32 210.89,480.82 204.19,480.81  "
  })), /*#__PURE__*/React.createElement("polygon", {
    className: "st1",
    points: "208.96,484.3 208.92,485.05 210.17,485.05 210.21,484.3  "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st1",
    points: "206.73,484.3 206.68,485.05 207.93,485.05 207.97,484.3  "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st1",
    points: "204.5,484.3 204.45,485.05 205.7,485.05 205.74,484.3  "
  }))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("polygon", {
    className: "st0",
    points: "210.5,488.32 217.25,488.32 217.58,480.83 210.89,480.82  "
  })), /*#__PURE__*/React.createElement("polygon", {
    className: "st1",
    points: "215.68,484.31 215.65,485.06 216.9,485.06 216.93,484.31  "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st1",
    points: "213.45,484.31 213.41,485.06 214.66,485.06 214.69,484.31  "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st1",
    points: "211.22,484.31 211.18,485.05 212.43,485.06 212.46,484.31  "
  }))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("polygon", {
    className: "st0",
    points: "217.25,488.32 224.01,488.33 224.27,480.83 217.58,480.83  "
  })), /*#__PURE__*/React.createElement("polygon", {
    className: "st1",
    points: "222.41,484.32 222.38,485.07 223.63,485.07 223.65,484.32  "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st1",
    points: "220.17,484.31 220.14,485.06 221.39,485.06 221.42,484.31  "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st1",
    points: "217.94,484.31 217.91,485.06 219.15,485.06 219.19,484.31  "
  }))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("polygon", {
    className: "st0",
    points: "224.01,488.33 230.76,488.34 230.97,480.84 224.27,480.83  "
  })), /*#__PURE__*/React.createElement("polygon", {
    className: "st1",
    points: "229.13,484.32 229.1,485.07 230.35,485.07 230.37,484.32  "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st1",
    points: "226.89,484.32 226.86,485.07 228.11,485.07 228.14,484.32  "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st1",
    points: "224.66,484.32 224.63,485.07 225.88,485.07 225.91,484.32  "
  }))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("polygon", {
    className: "st0",
    points: "230.76,488.34 237.51,488.34 237.66,480.84 230.97,480.84  "
  })), /*#__PURE__*/React.createElement("polygon", {
    className: "st1",
    points: "235.85,484.33 235.83,485.08 237.08,485.08 237.1,484.33  "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st1",
    points: "233.61,484.33 233.59,485.08 234.84,485.08 234.86,484.33  "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st1",
    points: "231.38,484.32 231.36,485.07 232.61,485.07 232.63,484.32  "
  }))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("polygon", {
    className: "st0",
    points: "237.51,488.34 244.26,488.35 244.36,480.85 237.66,480.84  "
  })), /*#__PURE__*/React.createElement("polygon", {
    className: "st1",
    points: "242.57,484.33 242.56,485.08 243.81,485.08 243.82,484.33  "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st1",
    points: "240.33,484.33 240.32,485.08 241.57,485.08 241.58,484.33  "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st1",
    points: "238.1,484.33 238.09,485.08 239.33,485.08 239.35,484.33  "
  }))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("polygon", {
    className: "st0",
    points: "244.26,488.35 251.01,488.36 251.05,480.86 244.36,480.85  "
  })), /*#__PURE__*/React.createElement("polygon", {
    className: "st1",
    points: "249.29,484.34 249.28,485.09 250.53,485.09 250.54,484.34  "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st1",
    points: "247.05,484.34 247.05,485.09 248.29,485.09 248.3,484.34  "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st1",
    points: "244.82,484.34 244.81,485.09 246.06,485.09 246.07,484.34  "
  }))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M251.01,488.36c0.47,0,1.38,0,2.14-0.09c0.78-0.09,1.57-0.26,2.37-0.52c0.79-0.25,1.61-0.62,2.42-1.15 c0.2-0.13,0.4-0.27,0.6-0.44c0.23-0.18,0.45-0.36,0.64-0.56c0.4-0.39,0.75-0.83,1.06-1.3l-6.37-4l0,0c0,0,0-0.01,0.01-0.01 c-0.01,0.01-0.04,0.04-0.08,0.05c-0.12,0.08-0.34,0.2-0.61,0.28c-0.27,0.08-0.58,0.16-0.91,0.2 c-0.36,0.04-0.57,0.04-1.22,0.04L251.01,488.36z"
  })), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M255.67,483.28l0.41,0.63c0.38-0.23,0.75-0.56,1.06-0.9l-0.58-0.48 C256.29,482.82,256.01,483.08,255.67,483.28z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M253.69,484.1l0.18,0.73c0.43-0.11,0.85-0.23,1.26-0.42l-0.3-0.69C254.47,483.89,254.08,484,253.69,484.1z "
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M251.54,484.34l0,0.75c0.43,0,0.87-0.02,1.31-0.08l-0.09-0.74C252.35,484.32,251.95,484.34,251.54,484.34z "
  }))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M260.23,484.3c0.61-0.93,0.98-2.02,1.08-3.14c0.03-0.28,0.06-0.56,0.05-0.84l0-0.44l0-0.84l0-3.36l-7.5,0 l0,3.37l0,0.84l0,0.4h0l0,0L260.23,484.3z"
  })), /*#__PURE__*/React.createElement("rect", {
    x: 257.34,
    y: 476.19,
    className: "st1",
    width: 0.75,
    height: 1.25
  }), /*#__PURE__*/React.createElement("rect", {
    x: 257.35,
    y: 478.43,
    className: "st1",
    width: 0.75,
    height: 1.25
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M257.06,481.75l0.69,0.31c0.2-0.43,0.31-0.89,0.34-1.36l-0.75-0.07 C257.31,481.02,257.22,481.4,257.06,481.75z"
  }))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("polygon", {
    className: "st0",
    points: "261.36,475.69 261.35,468.98 253.85,468.96 253.86,475.69  "
  })), /*#__PURE__*/React.createElement("polygon", {
    className: "st1",
    points: "257.34,470.71 258.09,470.71 258.09,469.47 257.34,469.46  "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st1",
    points: "257.34,472.95 258.09,472.95 258.09,471.7 257.34,471.7  "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st1",
    points: "257.34,475.18 258.09,475.18 258.09,473.93 257.34,473.93  "
  }))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("polygon", {
    className: "st0",
    points: "261.35,468.98 261.34,462.26 253.84,462.23 253.85,468.96  "
  })), /*#__PURE__*/React.createElement("polygon", {
    className: "st1",
    points: "257.33,463.99 258.08,463.99 258.08,462.74 257.33,462.74  "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st1",
    points: "257.33,466.23 258.08,466.23 258.08,464.98 257.33,464.98  "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st1",
    points: "257.33,468.46 258.08,468.46 258.08,467.21 257.33,467.21  "
  }))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("polygon", {
    className: "st0",
    points: "261.34,462.26 261.33,455.54 253.84,455.5 253.84,462.23  "
  })), /*#__PURE__*/React.createElement("polygon", {
    className: "st1",
    points: "257.32,457.27 258.07,457.27 258.07,456.02 257.32,456.02  "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st1",
    points: "257.32,459.5 258.07,459.51 258.07,458.26 257.32,458.26  "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st1",
    points: "257.33,461.73 258.08,461.74 258.08,460.49 257.33,460.49  "
  }))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("polygon", {
    className: "st0",
    points: "261.33,455.54 261.33,448.83 253.83,448.77 253.84,455.5  "
  })), /*#__PURE__*/React.createElement("polygon", {
    className: "st1",
    points: "257.31,450.54 258.06,450.55 258.06,449.3 257.31,449.29  "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st1",
    points: "257.32,452.78 258.07,452.78 258.07,451.54 257.32,451.53  "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st1",
    points: "257.32,455.01 258.07,455.02 258.07,453.77 257.32,453.76  "
  }))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("polygon", {
    className: "st0",
    points: "261.33,448.83 261.32,442.11 253.82,442.04 253.83,448.77  "
  })), /*#__PURE__*/React.createElement("polygon", {
    className: "st1",
    points: "257.31,443.82 258.06,443.82 258.06,442.58 257.31,442.57  "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st1",
    points: "257.31,446.06 258.06,446.06 258.06,444.82 257.31,444.81  "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st1",
    points: "257.31,448.29 258.06,448.29 258.06,447.05 257.31,447.04  "
  }))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("polygon", {
    className: "st0",
    points: "261.32,442.11 261.31,435.4 253.81,435.31 253.82,442.04  "
  })), /*#__PURE__*/React.createElement("polygon", {
    className: "st1",
    points: "257.3,437.09 258.05,437.1 258.05,435.85 257.3,435.85  "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st1",
    points: "257.3,439.33 258.05,439.34 258.05,438.09 257.3,438.08  "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st1",
    points: "257.3,441.56 258.05,441.57 258.05,440.32 257.3,440.32  "
  }))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("polygon", {
    className: "st0",
    points: "261.31,435.4 261.3,428.68 253.81,428.58 253.81,435.31  "
  })), /*#__PURE__*/React.createElement("polygon", {
    className: "st1",
    points: "257.29,430.37 258.04,430.38 258.04,429.13 257.29,429.12  "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st1",
    points: "257.29,432.61 258.04,432.62 258.04,431.37 257.29,431.36  "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st1",
    points: "257.3,434.84 258.05,434.85 258.04,433.6 257.29,433.59  "
  }))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M261.3,428.68l0-0.42l0.01-0.13c0.01-0.14,0.03-0.29,0.07-0.46c0.06-0.33,0.16-0.68,0.29-1.01 c0.22-0.66,0.67-1.22,0.61-1.13l-4.58-5.93c-0.92,0.71-1.53,1.52-1.98,2.24c-0.46,0.74-0.79,1.45-1.06,2.17 c-0.27,0.72-0.48,1.45-0.63,2.22c-0.08,0.38-0.13,0.78-0.17,1.21c-0.02,0.2-0.03,0.48-0.04,0.71l0,0.42L261.3,428.68z"
  })), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M258.63,423.75l0.64,0.39c0.2-0.33,0.43-0.64,0.69-0.9l-0.53-0.53 C259.12,423.03,258.86,423.38,258.63,423.75z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M257.71,425.85l0.72,0.22c0.11-0.38,0.26-0.75,0.42-1.11l-0.68-0.31 C257.98,425.05,257.83,425.45,257.71,425.85z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M257.29,428.11l0.75,0.02c0.02-0.37,0.07-0.77,0.15-1.15l-0.73-0.15 C257.37,427.25,257.31,427.67,257.29,428.11z"
  }))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M262.28,425.54c0.01,0,0.09-0.07,0.31-0.13c0.22-0.07,0.54-0.13,0.92-0.17c0.39-0.04,0.84-0.06,1.33-0.06 l1.67,0l-0.05-7.5l-1.69,0c-0.62,0.01-1.3,0.03-2.02,0.1c-0.73,0.08-1.52,0.2-2.38,0.47c-0.85,0.26-1.79,0.69-2.68,1.36 L262.28,425.54z"
  })), /*#__PURE__*/React.createElement("polygon", {
    className: "st1",
    points: "264.75,421.16 264.75,421.91 266,421.91 265.99,421.16  "
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M262.48,421.33l0.12,0.74c0.39-0.06,0.79-0.1,1.19-0.12l-0.04-0.75 C263.32,421.22,262.9,421.26,262.48,421.33z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M260.28,422.06l0.38,0.65c0.32-0.19,0.67-0.33,1.04-0.44l-0.21-0.72 C261.07,421.67,260.66,421.84,260.28,422.06z"
  }))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    x: 266.47,
    y: 417.67,
    className: "st0",
    width: 6.72,
    height: 7.5
  })), /*#__PURE__*/React.createElement("rect", {
    x: 271.45,
    y: 421.16,
    className: "st1",
    width: 1.25,
    height: 0.75
  }), /*#__PURE__*/React.createElement("rect", {
    x: 269.21,
    y: 421.16,
    className: "st1",
    width: 1.25,
    height: 0.75
  }), /*#__PURE__*/React.createElement("rect", {
    x: 266.98,
    y: 421.16,
    className: "st1",
    width: 1.25,
    height: 0.75
  }))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    x: 273.2,
    y: 417.67,
    className: "st0",
    width: 6.72,
    height: 7.5
  })), /*#__PURE__*/React.createElement("rect", {
    x: 278.17,
    y: 421.15,
    className: "st1",
    width: 1.25,
    height: 0.75
  }), /*#__PURE__*/React.createElement("rect", {
    x: 275.94,
    y: 421.15,
    className: "st1",
    width: 1.25,
    height: 0.75
  }), /*#__PURE__*/React.createElement("rect", {
    x: 273.7,
    y: 421.15,
    className: "st1",
    width: 1.25,
    height: 0.75
  }))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    x: 279.92,
    y: 417.66,
    className: "st0",
    width: 6.72,
    height: 7.5
  })), /*#__PURE__*/React.createElement("rect", {
    x: 284.9,
    y: 421.14,
    className: "st1",
    width: 1.25,
    height: 0.75
  }), /*#__PURE__*/React.createElement("rect", {
    x: 282.66,
    y: 421.14,
    className: "st1",
    width: 1.25,
    height: 0.75
  }), /*#__PURE__*/React.createElement("rect", {
    x: 280.43,
    y: 421.15,
    className: "st1",
    width: 1.25,
    height: 0.75
  }))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    x: 286.64,
    y: 417.65,
    className: "st0",
    width: 6.72,
    height: 7.5
  })), /*#__PURE__*/React.createElement("rect", {
    x: 291.62,
    y: 421.14,
    className: "st1",
    width: 1.25,
    height: 0.75
  }), /*#__PURE__*/React.createElement("rect", {
    x: 289.39,
    y: 421.14,
    className: "st1",
    width: 1.25,
    height: 0.75
  }), /*#__PURE__*/React.createElement("rect", {
    x: 287.15,
    y: 421.14,
    className: "st1",
    width: 1.25,
    height: 0.75
  }))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    x: 293.37,
    y: 417.65,
    className: "st0",
    width: 6.72,
    height: 7.5
  })), /*#__PURE__*/React.createElement("rect", {
    x: 298.35,
    y: 421.13,
    className: "st1",
    width: 1.25,
    height: 0.75
  }), /*#__PURE__*/React.createElement("rect", {
    x: 296.11,
    y: 421.13,
    className: "st1",
    width: 1.25,
    height: 0.75
  }), /*#__PURE__*/React.createElement("rect", {
    x: 293.88,
    y: 421.13,
    className: "st1",
    width: 1.25,
    height: 0.75
  }))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    x: 300.09,
    y: 417.64,
    className: "st0",
    width: 6.72,
    height: 7.5
  })), /*#__PURE__*/React.createElement("rect", {
    x: 305.07,
    y: 421.12,
    className: "st1",
    width: 1.25,
    height: 0.75
  }), /*#__PURE__*/React.createElement("rect", {
    x: 302.83,
    y: 421.13,
    className: "st1",
    width: 1.25,
    height: 0.75
  }), /*#__PURE__*/React.createElement("rect", {
    x: 300.6,
    y: 421.13,
    className: "st1",
    width: 1.25,
    height: 0.75
  }))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    x: 306.82,
    y: 417.64,
    className: "st0",
    width: 6.72,
    height: 7.5
  })), /*#__PURE__*/React.createElement("rect", {
    x: 311.8,
    y: 421.12,
    className: "st1",
    width: 1.25,
    height: 0.75
  }), /*#__PURE__*/React.createElement("rect", {
    x: 309.56,
    y: 421.12,
    className: "st1",
    width: 1.25,
    height: 0.75
  }), /*#__PURE__*/React.createElement("rect", {
    x: 307.33,
    y: 421.12,
    className: "st1",
    width: 1.25,
    height: 0.75
  }))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    x: 313.54,
    y: 417.63,
    className: "st0",
    width: 6.72,
    height: 7.5
  })), /*#__PURE__*/React.createElement("rect", {
    x: 318.52,
    y: 421.11,
    className: "st1",
    width: 1.25,
    height: 0.75
  }), /*#__PURE__*/React.createElement("rect", {
    x: 316.28,
    y: 421.11,
    className: "st1",
    width: 1.25,
    height: 0.75
  }), /*#__PURE__*/React.createElement("rect", {
    x: 314.05,
    y: 421.12,
    className: "st1",
    width: 1.25,
    height: 0.75
  }))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    x: 320.27,
    y: 417.62,
    className: "st0",
    width: 6.72,
    height: 7.5
  })), /*#__PURE__*/React.createElement("rect", {
    x: 325.25,
    y: 421.11,
    className: "st1",
    width: 1.25,
    height: 0.75
  }), /*#__PURE__*/React.createElement("rect", {
    x: 323.01,
    y: 421.11,
    className: "st1",
    width: 1.25,
    height: 0.75
  }), /*#__PURE__*/React.createElement("rect", {
    x: 320.78,
    y: 421.11,
    className: "st1",
    width: 1.25,
    height: 0.75
  }))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M327.01,425.12l3.36,0c0.62,0,1.01,0.12,1.36,0.31l3.71-6.52c-1.6-0.92-3.47-1.3-5.09-1.29l-3.36,0 L327.01,425.12z"
  })), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M332.03,421.28l-0.17,0.73c0.38,0.08,0.74,0.21,1.09,0.36l0.31-0.68 C332.86,421.52,332.45,421.37,332.03,421.28z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M329.74,421.1l0,0.75c0.42,0,0.83,0,1.21,0.02l0.06-0.75C330.57,421.1,330.15,421.1,329.74,421.1z"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st1",
    points: "327.51,421.1 327.51,421.85 328.76,421.85 328.76,421.1  "
  }))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M331.74,425.42c0.33,0.2,0.52,0.41,0.62,0.66c0.06,0.12,0.09,0.27,0.1,0.45c0,0.07,0.01,0.04,0.01,0.18 l0,0.42l0.01,0.85l7.5-0.12l-0.01-0.83l0-0.42c0-0.14-0.02-0.44-0.03-0.65c-0.07-0.93-0.28-1.9-0.68-2.81 c-0.76-1.83-2.19-3.33-3.81-4.24L331.74,425.42z"
  })), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M336.45,426.15l-0.75,0.07c0.03,0.36,0.03,0.8,0.03,1.21l0.75-0.01 C336.48,427,336.49,426.59,336.45,426.15z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M335.75,423.92l-0.65,0.38c0.18,0.33,0.34,0.67,0.44,1.03l0.72-0.2 C336.15,424.71,335.97,424.3,335.75,423.92z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M334.17,422.22l-0.43,0.62c0.31,0.22,0.6,0.47,0.84,0.75l0.56-0.5 C334.86,422.76,334.53,422.47,334.17,422.22z"
  }))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("polygon", {
    className: "st0",
    points: "332.48,427.98 332.53,434.75 340.02,434.53 339.97,427.86  "
  })), /*#__PURE__*/React.createElement("polygon", {
    className: "st1",
    points: "336.53,432.89 335.78,432.91 335.79,434.16 336.54,434.14  "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st1",
    points: "336.51,430.65 335.76,430.67 335.77,431.92 336.52,431.9  "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st1",
    points: "336.49,428.42 335.74,428.44 335.75,429.68 336.5,429.67  "
  }))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("polygon", {
    className: "st0",
    points: "332.53,434.75 332.58,441.52 340.08,441.21 340.02,434.53  "
  })), /*#__PURE__*/React.createElement("polygon", {
    className: "st1",
    points: "336.58,439.61 335.83,439.64 335.84,440.89 336.59,440.86  "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st1",
    points: "336.56,437.37 335.81,437.4 335.82,438.65 336.57,438.62  "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st1",
    points: "336.54,435.14 335.8,435.16 335.8,436.41 336.55,436.39  "
  }))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("polygon", {
    className: "st0",
    points: "332.58,441.52 332.64,448.29 340.13,447.88 340.08,441.21  "
  })), /*#__PURE__*/React.createElement("polygon", {
    className: "st1",
    points: "336.63,446.33 335.88,446.37 335.89,447.62 336.64,447.58  "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st1",
    points: "336.61,444.09 335.86,444.13 335.87,445.38 336.62,445.34  "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st1",
    points: "336.6,441.86 335.85,441.89 335.86,443.14 336.61,443.11  "
  }))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("polygon", {
    className: "st0",
    points: "332.64,448.29 332.69,455.06 340.18,454.56 340.13,447.88  "
  })), /*#__PURE__*/React.createElement("polygon", {
    className: "st1",
    points: "336.68,453.05 335.93,453.1 335.94,454.34 336.69,454.3  "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st1",
    points: "336.67,450.81 335.92,450.86 335.93,452.1 336.67,452.06  "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st1",
    points: "336.65,448.58 335.9,448.62 335.91,449.87 336.66,449.83  "
  }))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("polygon", {
    className: "st0",
    points: "332.69,455.06 332.74,461.83 340.23,461.23 340.18,454.56  "
  })), /*#__PURE__*/React.createElement("polygon", {
    className: "st1",
    points: "336.73,459.77 335.99,459.82 335.99,461.07 336.74,461.01  "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st1",
    points: "336.72,457.53 335.97,457.58 335.98,458.83 336.73,458.78  "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st1",
    points: "336.7,455.3 335.95,455.35 335.96,456.6 336.71,456.55  "
  }))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("polygon", {
    className: "st0",
    points: "332.74,461.83 332.8,468.6 340.28,467.91 340.23,461.23  "
  })), /*#__PURE__*/React.createElement("polygon", {
    className: "st1",
    points: "336.79,466.49 336.04,466.55 336.05,467.8 336.8,467.73  "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st1",
    points: "336.77,464.25 336.02,464.31 336.03,465.56 336.78,465.5  "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st1",
    points: "336.75,462.02 336,462.08 336.01,463.33 336.76,463.27  "
  }))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("polygon", {
    className: "st0",
    points: "332.8,468.6 332.85,475.37 340.33,474.59 340.28,467.91  "
  })), /*#__PURE__*/React.createElement("polygon", {
    className: "st1",
    points: "336.84,473.21 336.09,473.28 336.1,474.53 336.85,474.45  "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st1",
    points: "336.82,470.97 336.07,471.04 336.08,472.29 336.83,472.22  "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st1",
    points: "336.8,468.74 336.05,468.81 336.06,470.06 336.81,469.99  "
  }))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("polygon", {
    className: "st0",
    points: "332.85,475.37 332.88,478.76 332.89,480.45 332.9,481.29 332.9,481.72 332.97,482.52  340.38,480.87 340.33,474.59  "
  })), /*#__PURE__*/React.createElement("polygon", {
    className: "st1",
    points: "336.89,479.93 336.14,480.01 336.15,481.26 336.9,481.17  "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st1",
    points: "336.87,477.69 336.12,477.77 336.13,479.02 336.88,478.94  "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st1",
    points: "336.85,475.46 336.11,475.54 336.12,476.79 336.86,476.71  "
  }))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M332.97,482.52c0.13,1.1,0.47,2.14,1.06,3.02c0.58,0.89,1.42,1.6,2.38,2.07 c0.96,0.47,2.06,0.67,3.17,0.73c1.27,0.05,1.56-0.01,2.17,0.01l-0.18-7.5l-1.19,0.01L332.97,482.52z"
  })), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M339.94,484.35l-0.09,0.75c0.48,0.02,0.91-0.01,1.32-0.01l-0.02-0.75 C340.73,484.34,340.32,484.37,339.94,484.35z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M337.95,483.86l-0.49,0.6c0.39,0.26,0.83,0.42,1.29,0.51l0.28-0.71 C338.65,484.2,338.27,484.07,337.95,483.86z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M336.96,482.11l-0.72,0.26c0.08,0.46,0.22,0.91,0.47,1.3l0.62-0.47 C337.13,482.87,337.02,482.49,336.96,482.11z"
  }))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("polygon", {
    className: "st0",
    points: "341.75,488.35 348.46,488.32 348.3,480.83 341.57,480.85  "
  })), /*#__PURE__*/React.createElement("polygon", {
    className: "st1",
    points: "346.63,484.32 346.64,485.07 347.89,485.06 347.88,484.31  "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st1",
    points: "344.39,484.33 344.41,485.08 345.65,485.07 345.64,484.32  "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st1",
    points: "342.16,484.34 342.18,485.09 343.42,485.08 343.41,484.33  "
  }))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("polygon", {
    className: "st0",
    points: "348.46,488.32 355.17,488.29 355.04,480.8 348.3,480.83  "
  })), /*#__PURE__*/React.createElement("polygon", {
    className: "st1",
    points: "353.35,484.29 353.37,485.04 354.61,485.03 354.6,484.28  "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st1",
    points: "351.11,484.3 351.13,485.05 352.38,485.04 352.36,484.29  "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st1",
    points: "348.88,484.31 348.9,485.06 350.15,485.05 350.13,484.3  "
  }))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("polygon", {
    className: "st0",
    points: "355.17,488.29 361.88,488.26 361.77,480.77 355.04,480.8  "
  })), /*#__PURE__*/React.createElement("polygon", {
    className: "st1",
    points: "360.08,484.26 360.09,485.01 361.33,485 361.32,484.25  "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st1",
    points: "357.84,484.27 357.85,485.02 359.1,485.01 359.09,484.26  "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st1",
    points: "355.61,484.28 355.62,485.03 356.87,485.02 356.85,484.27  "
  }))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("polygon", {
    className: "st0",
    points: "361.88,488.26 368.59,488.24 368.51,480.74 361.77,480.77  "
  })), /*#__PURE__*/React.createElement("polygon", {
    className: "st1",
    points: "366.8,484.23 366.81,484.98 368.06,484.97 368.05,484.22  "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st1",
    points: "364.56,484.24 364.57,484.99 365.82,484.98 365.81,484.23  "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st1",
    points: "362.33,484.25 362.34,485 363.59,484.99 363.58,484.24  "
  }))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("polygon", {
    className: "st0",
    points: "368.59,488.24 375.3,488.21 375.24,480.71 368.51,480.74  "
  })), /*#__PURE__*/React.createElement("polygon", {
    className: "st1",
    points: "373.52,484.2 373.53,484.95 374.78,484.94 374.77,484.19  "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st1",
    points: "371.29,484.21 371.29,484.96 372.54,484.95 372.53,484.2  "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st1",
    points: "369.05,484.22 369.06,484.97 370.31,484.96 370.3,484.21  "
  }))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("polygon", {
    className: "st0",
    points: "375.3,488.21 382.01,488.18 381.98,480.68 375.24,480.71  "
  })), /*#__PURE__*/React.createElement("rect", {
    x: 380.25,
    y: 484.17,
    transform: "matrix(1 -5.208263e-03 5.208263e-03 1 -2.5185 1.9903)",
    className: "st1",
    width: 1.25,
    height: 0.75
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st1",
    points: "378.01,484.18 378.01,484.93 379.26,484.92 379.26,484.17  "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st1",
    points: "375.78,484.19 375.78,484.94 377.03,484.93 377.03,484.18  "
  }))))))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgSeonogte);
export default __webpack_public_path__ + "static/media/seonogte.5bf063aad8566f5644e9510c84fee97f.svg";
export { ForwardRef as ReactComponent };